/**
 * Lamnso' Calendar System
 * Based on the LamFonBooks.com calendar.
 * 
 * 8-day market week cycle, anchored to January 1, 2025 = Geegee.
 * 
 * Format: "[English weekday] wóo [Lamnso day] Vishííy [day#] fo Ŋwée wóo [Lamnso month] [year]"
 * Example: "Tuesday wóo Rəə́vəy Vishííy 7 fo Ŋwée wóo Vishévtì 2026"
 */

// 8-day Lamnso' market week (1-indexed as per the calendar)
const LAMNSO_DAYS = [
  "Kaáví",      // 1
  "Rəə́vəy",    // 2
  "Kiloòvəy",   // 3
  "Nsəə̀rí",    // 4
  "Geegee",     // 5
  "Ŋgòylùm",   // 6
  "Wáylùn",     // 7
  "Ntàŋrìn"     // 8
];

// Lamnso' months mapped to Gregorian months
const LAMNSO_MONTHS = [
  "Mfìílùm",        // January
  "Kifír",           // February
  "Kimgbù ke wuu",  // March
  "Vishévtì",        // April
  "Mà'àn sàŋ",      // May
  "Mà'àn saàr",     // June
  "Ntoòbìŋ",        // July
  "Tònŋkiŋ",        // August
  "Nkivìn",          // September
  "Virə́mrə́m",      // October
  "Sán",             // November
  "Ntinèn Saàr"     // December
];

// Anchor: January 1, 2025 = Geegee (index 4)
const ANCHOR_DATE = new Date(2025, 0, 1); // Jan 1, 2025
const ANCHOR_DAY_INDEX = 4; // Geegee

/**
 * Get the Lamnso' day name for any date.
 * The 8-day cycle runs continuously, anchored to Jan 1, 2025 = Geegee.
 */
function getLamnsoDayIndex(date) {
  const msPerDay = 86400000;
  const diffDays = Math.floor((date.getTime() - ANCHOR_DATE.getTime()) / msPerDay);
  // Modulo that handles negative numbers correctly
  return ((diffDays % 8) + ANCHOR_DAY_INDEX + 8) % 8;
}

/**
 * Get full Lamnso' date information for any date.
 */
export function getLamnsoDate(date = new Date()) {
  const dayIndex = getLamnsoDayIndex(date);
  const lamnsoDay = LAMNSO_DAYS[dayIndex];
  const lamnsoMonth = LAMNSO_MONTHS[date.getMonth()];
  const dayOfMonth = date.getDate();
  const year = date.getFullYear();

  // English weekday
  const englishDay = date.toLocaleDateString('en-US', { weekday: 'long' });

  // Gregorian date string MM/DD/YYYY
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(dayOfMonth).padStart(2, '0');
  const gregorian = `${mm}/${dd}/${year}`;

  // LamFonBooks format:
  // "Tuesday wóo Rəə́vəy Vishííy 7 fo Ŋwée wóo Vishévtì 2026"
  const formatted = `${englishDay} wóo ${lamnsoDay} Vishííy ${dayOfMonth} fo Ŋwée wóo ${lamnsoMonth} ${year}`;

  return {
    day: lamnsoDay,
    dayIndex: dayIndex + 1, // 1-based for display
    dayOfMonth,
    month: lamnsoMonth,
    monthIndex: date.getMonth(),
    year,
    englishDay,
    gregorian,
    formatted,
    short: `${dayOfMonth} ${lamnsoMonth}`
  };
}

export { LAMNSO_MONTHS, LAMNSO_DAYS };
